<template>
  <div class="container-fluid">
    <div class="h2 text-center">
      {{ labels.selectProject || 'Select Project' }}
    </div>
    <div class="row justify-content-md-center">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-header bg-secondary text-white text-center">
            {{ labels.availableProjects || 'Available Projects' }}
          </div>
          <div class="card-body">
            <div v-if="Object.keys(projects).length === 0" class="text-center text-muted">
              {{ labels.noProjectsAvailable || 'No projects available' }}
            </div>
            <div v-else class="row">
              <div 
                v-for="(project, key) in activeProjects"
                :key="key"
                class="col-md-6 col-lg-4 mb-3"
              >
                <div class="card project-card h-100" @click="selectProject(key)">
                  <div class="card-body d-flex flex-column">
                    <h5 class="card-title">{{ project.documentTitle || project.name || key }}</h5>
                    <p class="card-text flex-grow-1">
                      <small class="text-muted">{{ project.navbarTitle || project.documentTitle || '' }}</small>
                    </p>
                    <div class="mt-auto">
                      <b-button variant="primary" size="sm" @click.stop="selectProject(key)">
                        {{ labels.selectProject || 'Select' }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectSettingsList',
  computed: {
    projects() {
      return this.$store.state.settings.projects || {}
    },
    labels() {
      return this.$store.state.labels.helpPage || {}
    },
    activeProjects() {
      // Filter projects to only include those that are active
      return Object.fromEntries(
        Object.entries(this.projects).filter(([key, project]) => project.active)
      )
    }
  },
  methods: {
    selectProject(projectKey) {
      try {
        // Use the SET_PROJECT mutation to change the current project
        this.$store.commit('settings/SET_PROJECT', projectKey)
        // Optionally redirect to a main page after selection
        // You might want to customize this based on your app's routing needs
        // this.$router.push('/')
        // not working...
        // this.$store.dispatch('setCouchDBUrl', {force: true})
        // force a refresh
        window.location.reload()
      } catch (error) {
        console.error('Error selecting project:', error)
        // You could add error handling here, such as showing a notification
      }
    }
  }
}
</script>

<style scoped>
.project-card {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border: 1px solid #dee2e6;
}

.project-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  border-color: #007bff;
}

.project-card .card-body {
  padding: 1rem;
}

.project-card .card-title {
  color: #495057;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.project-card .card-text {
  font-size: 0.9rem;
  color: #6c757d;
}
</style>
